const subjectApi = {
  GETCOURSELISTALL: 'CSVPA-China/api/course/getListAll', //所有科目
  GETSUBJECTLISTBYUSERID: 'CSVPA-China/api/course/getListByUserId', //老师教的科目
  GETCOURSERESULTSBYSTUDENTID:
    'CSVPA-China/api/course/getCourseResultsByStudentId', //老师教的学生科目成绩
  GETTRANSCRIPTUPDATE: 'CSVPA-China/api/course/getTranscriptUpdate', //提交的修改数据
  COURSEUpdate: 'CSVPA-China/api/course/update', //编辑课程
  ADDSUBJECT: 'CSVPA-China/api/course/save', //添加课程
  GETTEACHERSDATA: 'CSVPA-China/api/teaching-course/page', //获取任课老师
  DELETESUBJECT: 'CSVPA-China/api/course/delete', //删除科目
  TEACHEREDIT: 'CSVPA-China/api/teaching-course/edit', //老师配置科目
  // getAllCourseList: 'CSVPA-China/api/course/getCoursePage', //获取课程列表
  // getAllCourseList: 'CSVPA-China/api/course/getCoursePage', //获取课程列表
  getAllCourseList: 'CSVPA-China/api/course/getCoursePage' //获取课程列表
}

export default subjectApi
